import React from "react";
import PropTypes from "prop-types";


class CalculationString extends React.PureComponent {
    static propTypes = {
        coeffInfo: PropTypes.objectOf(PropTypes.shape({
            color: PropTypes.string,
            description: PropTypes.string,
        })),
        string: PropTypes.string,
        prefix: PropTypes.string,
    }

    static defaultProps = {
        prefix: 'Расчет: ',
    }

    constructor(props) {
        super(props);

        const abstractString = props.prefix + props.string.replace(/{(\d):(.*?)}/g, (match, p1, p2, offset, string, groups) => {
            const coeff = `k${p1}`;
            const className = props.coeffInfo[coeff].color;
            return `<span class="${className}">${coeff}</span>`;
        });
        const explicitString = props.prefix + props.string.replace(/{(\d):(.*?)}/g, (match, p1, p2, offset, string, groups) => {
            const coeff = `k${p1}`;
            const className = props.coeffInfo[coeff].color;
            return `<span class="${className}">${p2}</span>`;
        });

        this.state = {
            opened: false,
            abstractString: {__html: abstractString},
            explicitString: {__html: explicitString},
        }
    }

    toggleStrings = () => this.setState(({opened}) => ({opened: !opened}));

    render() {
        const {opened, abstractString, explicitString} = this.state;

        if (opened) {
            const coeffDivs = Object.keys(this.props.coeffInfo)
                .sort((a, b) => a.localeCompare(b))
                .map(coeff => {
                    const {color, description} = this.props.coeffInfo[coeff];
                    return <div key={coeff} className={color}>{coeff} -- {description}</div>;
                });

            return (
                <div className="text-italic">
                    <div className="c-hand" onClick={this.toggleStrings} dangerouslySetInnerHTML={abstractString}></div>
                    {coeffDivs}
                </div>
            );
        } else {
            return <div className="text-italic c-hand" onClick={this.toggleStrings} dangerouslySetInnerHTML={explicitString}/>;
        }
    }
}


export default CalculationString;